import React from 'react';

export interface LogoProps {
  variant?: 'main' | 'icon' | 'mono';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  xs: 'w-6 h-6',
  sm: 'w-8 h-8', 
  md: 'w-12 h-12',
  lg: 'w-16 h-16',
  xl: 'w-24 h-24'
};

const logoSources = {
  main: '/logo-sf-main.svg?v=custom-logo',
  icon: '/logo-sf-icon.svg?v=custom-logo', 
  mono: '/logo-sf-mono.svg?v=custom-logo'
};

export const Logo: React.FC<LogoProps> = ({ 
  variant = 'main', 
  size = 'md', 
  className = '' 
}) => {
  const baseClasses = `${sizeClasses[size]} object-contain`;
  const combinedClasses = className ? `${baseClasses} ${className}` : baseClasses;

  return (
    <img
      src={logoSources[variant]}
      alt="Logo Suh Freitas"
      className={combinedClasses}
      key={`logo-${variant}-${size}`}
    />
  );
};

// Componente específico para uso como ícone inline
export const LogoIcon: React.FC<Omit<LogoProps, 'variant'>> = (props) => (
  <Logo {...props} variant="icon" />
);

// Componente específico para uso monocromático
export const LogoMono: React.FC<Omit<LogoProps, 'variant'>> = (props) => (
  <Logo {...props} variant="mono" />
); 